export default __webpack_public_path__ + "static/media/ic-cancel.8c0f29f8.svg";